// dependencies
import React from "react";

import {
	CloseOrDeleteSurveyModal,
	NoParticipantsSelectedModal,
	PublishSurveyInvalidModal,
	PublishSurveyModal,
	PublishSurveySuccessModal,
	SaveAsCopyModal,
	SelectAllEmployeesModal,
	ShareSurveyModal,
	SurveySettingsModal,
} from "./Modals";

/**
 * Renders all modals for the SurveyDetails page, only one can be open
 * and that is managed by the modal state in the store
 */
const SurveyDetailsModals = ({
	surveyId,
	surveyName,
	resetForm,
}: {
	surveyId: string;
	surveyName: string;
	resetForm: () => void;
}) => {
	return (
		<div>
			<PublishSurveyModal surveyId={surveyId} />
			<PublishSurveyInvalidModal />
			<PublishSurveySuccessModal />
			<SaveAsCopyModal surveyId={surveyId} surveyName={surveyName} />
			<CloseOrDeleteSurveyModal surveyId={surveyId} resetForm={resetForm} />
			<ShareSurveyModal surveyId={surveyId} />
			<SurveySettingsModal surveyId={surveyId} />
			<SelectAllEmployeesModal surveyId={surveyId} />
			<NoParticipantsSelectedModal />
		</div>
	);
};

export default SurveyDetailsModals;
